// Mirrors ReviewerProfileCompletenessValidator.cs's EmailRegex EXACTLY — mutually-exclusive
// negated character classes with no nested/overlapping quantifiers, so it can't backtrack
// catastrophically regardless of input.
export const EMAIL_FORMAT_REGEX = /^[^@\s]+@[^@\s]+\.[^@\s]+$/i;

export const isValidEmail = (email?: string): boolean => !!email && EMAIL_FORMAT_REGEX.test(email);
